module.exports = __webpack_public_path__ + "static/media/3.bb65330b.png";